import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Elements, StripeProvider } from "react-stripe-elements";

const test = false;

const apiKey = test ? 'pk_test_JUTAch3ykQJWjz3WDLgGhfzQ' : 'pk_live_Qp1SK17y6b6oQ4RCwl8IDFJY';

const reducer = combineReducers({
    form: reduxFormReducer
});

const store = (window.devToolsExtension
    ? window.devToolsExtension()(createStore)
    : createStore)(reducer);

ReactDOM.render(
    <Provider store={store}>
        <StripeProvider apiKey={apiKey}>
            <Elements>
                <App />
            </Elements>
        </StripeProvider>
    </Provider>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js